import styles from './ToggleInput.module.css';
import { MouseEventHandler } from 'react';

type ToggleInputProps = {
  id: string;
  isChecked: boolean;
  onClick: MouseEventHandler<HTMLInputElement>;
  disabled: boolean;
  orange?: boolean;
};

export function ToggleInput({
  id,
  isChecked,
  onClick,
  disabled,
  orange,
}: ToggleInputProps) {
  return (
    <div className={styles['container']}>
      <div
        className={styles['toggle-container']}
        style={{
          backgroundColor: orange
            ? isChecked
              ? '#FF7C62'
              : 'var(--ea-gray)'
            : isChecked
            ? 'var(--ea-blue)'
            : 'var(--ea-gray)',
        }}
      >
        <div
          className={styles['toggle-button']}
          style={{
            left: isChecked ? 'var(--toggle-travel-distance)' : '-1px',
          }}
        />
        <input
          id={id}
          checked={isChecked}
          disabled={disabled}
          onClick={onClick}
          type="checkbox"
          onChange={() => {}}
          className={styles['hidden-input']}
        />
      </div>
    </div>
  );
}
